import stIllionAuth from './illionAuth.component';
import stIllionAccessSeekerDialog from './illionAccessSeekerDialog.component';
import stIllionBankStatements from './illionBankStatementsAuth.component';
import stIllionBankStatementsButton from './illionBankStatementsButton.component';
import stIllionCompanyExtractPlusDialog from './illionCompanyExtractPlusDialog.component';

export default angular
  .module('st.Integrations.Illion', [])
  .component('stIllionAuth', stIllionAuth)
  .component('stIllionAccessSeekerDialog', stIllionAccessSeekerDialog)
  .component('stIllionBankStatements', stIllionBankStatements)
  .component('stIllionBankStatementsButton', stIllionBankStatementsButton)
  .component('stIllionCompanyExtractPlusDialog', stIllionCompanyExtractPlusDialog)
  .service('illionService', ($q, $http, dataService, ILLION) => ({
    accessSeeker: (params) =>
      dataService.apiRequest(
        null,
        null,
        true,
        null,
        $http.post,
        ILLION.API.ACCESS_SEEKER,
        {
          params
        },
        null
      ),
    bankStatementsEmailInvite: (params) =>
      dataService.apiRequest(
        null,
        null,
        true,
        null,
        $http.get,
        ILLION.API.BANK_STATEMENTS.EMAIL_INVITE,
        { params },
        null
      ),
    bankStatementsIsInvited: (params) =>
      dataService.apiRequest(
        null,
        null,
        true,
        null,
        $http.get,
        ILLION.API.BANK_STATEMENTS.IS_INVITED,
        { params },
        null
      ),
    companyExtractPlus: (params) =>
      dataService.apiRequest(
        null,
        null,
        true,
        null,
        $http.post,
        ILLION.API.COMPANY_EXTRACT_PLUS,
        {
          params
        },
        null
      )
  }))
  .constant('ILLION', {
    API: {
      ACCESS_SEEKER: '/api/v1/integration/illion/access-seeker/',
      BANK_STATEMENTS: {
        EMAIL_INVITE: '/api/v1/integrations/illion/bank-statements-email-invite/',
        IS_INVITED: '/api/v1/integrations/illion/bank-statements-is-invited/'
      },
      COMPANY_EXTRACT_PLUS: '/api/v1/integration/illion/company-extract-plus/'
    },
    CREDIT_OBLIGATION: ['Director', 'Guarantor', 'Joint', 'Principal', 'Proprietor'],
    LOOKUP_METHOD: ['ABN', 'ACN'],
    ACCOUNT_TYPE_ACCESS_SEEKER: [
      'Debit Card',
      'Hire Purchase',
      'Lease Agreement',
      'Loan Contract',
      'Mortgage Insurance',
      'Other Mortgage',
      'Other',
      'Overdraft',
      'Real Estate Mortgage',
      'Rental or Equipment Hire',
      'Revolving Credit',
      'Telecommunications',
      'Terms',
      'Transactional or Cheque Account',
      'Utilities',
      'Hire Purchase and Revolving Credit'
    ],
    ACCOUNT_TYPE_COMMERCIAL: [
      'Real Estate Mortgage',
      'Telecommunications',
      'Terms',
      'Loan Contract',
      'Utilities',
      'Overdraft',
      'Rental or Equipment Hire',
      'Other',
      'Trade Finance',
      'Hire Purchase',
      'Cash on Delivery',
      'Revolving Credit',
      'Bill Of Sale',
      'Lease Agreement',
      'Dealership',
      'Bridging Finance',
      'Debit Card',
      "Director's Access",
      'Factored Account',
      'Hire Purchase and Revolving Credit',
      'Lending Proposal',
      'Mortgage Insurance',
      'Other Mortgage',
      'Premium Finance',
      'Professional Inquiry',
      'Search Request',
      'Transactional or Cheque Account',
      'Wholesale Finance',
      'Work Cover'
    ]
  });
